import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { schedulesStateSelector } from "./schedulesStateSelector";

export const workflowCreationDialogOpenSelector = createDraftSafeSelector(
  [schedulesStateSelector],
  ({ workflowCreationDrawerOpen }) => {
    return workflowCreationDrawerOpen;
  },
);
